import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-epsilon',
  templateUrl: './icon-epsilon.component.html',
  styleUrl: './icon-epsilon.component.scss',
  standalone: false
})
export class IconEpsilonComponent {
  @Input() tooltip?: string;
}
